import { useContext } from "react";
import { useAtom } from "jotai";
import { TiposAusenciaService } from "services/VacacionesService";
import {
	tipoAusenciaSeleccionadaAtom, ocultarFechasSolicitadasAtom,
	contabilizaHorasAtom
} from "../store/MisSolicitudesStore";
import { SecurityContext } from "context/SecurityContextProvider";

const useSeleccionarTipoAusencia = () => {
	const { getUsuarioAutenticado } = useContext(SecurityContext);
	const [tipoAusencia, setTipoAusencia] = useAtom(tipoAusenciaSeleccionadaAtom);
	const [ocultarFechasSolicitadas, setOcultarFechasSolicitadas] = useAtom(ocultarFechasSolicitadasAtom);
	const [contabilizaHoras, setContabilizaHoras] = useAtom(contabilizaHorasAtom);
	const isAceros = getUsuarioAutenticado().empresaSeleccionada.razonSocial.toUpperCase().includes("ACEROS CHILCA SAC")
		? true
		: false;

	const isSDF = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20330791684" ? true : false;
	const isManuelita = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20411051782" ? true : false;
	const isDemo = getUsuarioAutenticado().empresaSeleccionada?.ruc === "12345678901" ? true : false;
	const isSDFEnergia = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20512436090" ? true : false;

	const onChangeTipoAusencia = async (tipoAusenciaId) => {

		const respuesta = await TiposAusenciaService.buscarPorId(tipoAusenciaId);
		console.log("respuesta***", respuesta.data);

		setTipoAusencia(respuesta.data);
		if (respuesta.data
			&& ((isAceros && respuesta.data.descripcion === "Compensacion de Horas")
				|| (isSDF && respuesta.data.descripcion === "Cambio de Turno")
				|| (isSDFEnergia && respuesta.data.descripcion === "Cambio de Turno")
				|| (isDemo && respuesta.data.descripcion === "AUTORIZACIÓN HORAS EXTRAS")
				|| (isManuelita && respuesta.data.descripcion === "AUTORIZACIÓN HORAS EXTRAS"))) {
			setOcultarFechasSolicitadas(true);
		} else {
			setOcultarFechasSolicitadas(false);
		}
		//SDF || DEMO || MANUELITA
		setContabilizaHoras(false);
		if ((isSDF || isDemo || isManuelita || isSDFEnergia) && respuesta.data.contabilizarHoras) {
			setContabilizaHoras(true);
			setTipoAusencia({
				...respuesta.data,
				contabilizarHoras: false
			});
		}
		// else if (isSDF && !respuesta.data.contabilizarHoras) { 
		// 	setContabilizaHoras(false);
		// }
	};

	const limpiarTipoAusencia = () => {
		setTipoAusencia(undefined);
	};

	// Nueva función para actualizar contabilizarHoras
	const actualizarContabilizarHoras = (valor) => {
		if (tipoAusencia) {
			setTipoAusencia({
				...tipoAusencia,
				contabilizarHoras: valor
			});
		}
	};

	return {
		tipoAusencia, limpiarTipoAusencia, onChangeTipoAusencia,
		ocultarFechasSolicitadas, contabilizaHoras,
		actualizarContabilizarHoras
	};
};

export default useSeleccionarTipoAusencia;
